function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  fill: "currentColor",
  height: "1em",
  width: "1em",
  viewBox: "64 64 896 896"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M393.238 924.495V75.205c0-15.82-12.75-28.57-28.805-28.57H195.378c-16.056 0-28.806 12.75-28.806 28.57v849.29c0 15.82 12.75 28.806 28.806 28.806h169.055c16.055 0 28.805-12.75 28.805-28.806zM828.008 924.495V75.205c0-15.82-12.75-28.57-28.805-28.57H630.147c-16.055 0-28.805 12.75-28.805 28.57v849.29c0 15.82 12.75 28.806 28.805 28.806h169.056c16.055 0 28.805-12.75 28.805-28.806z"
})));